import { render, staticRenderFns } from "./InstanceEditOwners.vue?vue&type=template&id=749c1f5e&scoped=true&"
import script from "./InstanceEditOwners.vue?vue&type=script&lang=js&"
export * from "./InstanceEditOwners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749c1f5e",
  null
  
)

export default component.exports